function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 1.35714,
  x2: 13,
  y2: 1.35714,
  stroke: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 12.6426,
  y1: 1,
  x2: 12.6426,
  y2: 7,
  stroke: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 11.6429,
  x2: 1,
  y2: 11.6429,
  stroke: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 1.35742,
  y1: 12,
  x2: 1.35742,
  y2: 6,
  stroke: "currentColor"
});

function SvgIcFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxsaW5lIHgxPSI3IiB5MT0iMS4zNTcxNCIgeDI9IjEzIiB5Mj0iMS4zNTcxNCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KICAgIDxsaW5lIHgxPSIxMi42NDI2IiB5MT0iMSIgeDI9IjEyLjY0MjYiIHkyPSI3IiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgogICAgPGxpbmUgeDE9IjciIHkxPSIxMS42NDI5IiB4Mj0iMSIgeTI9IjExLjY0MjkiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CiAgICA8bGluZSB4MT0iMS4zNTc0MiIgeTE9IjEyIiB4Mj0iMS4zNTc0MiIgeTI9IjYiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgIcFullScreen as ReactComponent };